import PropTypes from 'prop-types'
import { isNil } from 'ramda'
import ActiveRecord from 'model/activeRecord'

class PriorAuthorizationRequestType extends ActiveRecord {
  constructor(init) {
    super(init)
    if (isNil(init)) return undefined
    this._claim_id = init.claim_id
    this._employee_id = init.employee_id
    this._id = init.id
    this._medication = init.medication
    this._mhk_rx_case_number = init.mhk_rx_case_number
    this._pa_status = init.pa_status
    this._requested_by = init.requested_by
  }

  static shape = {
    claim_id: PropTypes.string,
    employee_id: PropTypes.string.isRequired,
    id: PropTypes.string,
    medication: PropTypes.string,
    mhk_rx_case_number: PropTypes.string,
    pa_status: PropTypes.string,
    requested_by: PropTypes.string
  }

  get claim_id() {
    return this._claim_id
  }

  get employee_id() {
    return this._employee_id
  }

  get id() {
    return this._id
  }

  get medication() {
    return this._medication
  }

  get mhk_rx_case_number() {
    return this._mhk_rx_case_number
  }

  get pa_status() {
    return this._pa_status
  }

  get requested_by() {
    return this._requested_by
  }
}

export default PriorAuthorizationRequestType
